  
  export const webPortfolio = [
    {
      id: 1,
      title: "Branding SPA",
      img: "/assets/Branding_SPA.png",
      link:"https://jpj-branding-template.herokuapp.com/"
    },
    {
      id: 2,
      title: "Blog using Microservices",
      img: "/assets/blog-microservices.png",
      link: "https://github.com/jibujacob/Blog_MERN"
    },
    {
      id: 3,
      title: "Ecommerce App using Microservices",
      img: "/assets/Ecommerce.png",
      link: "https://github.com/jibujacob/E-commerce_MERN"
    },

    {
      id: 4,
      title: "Frontend Mentor Challenges",
      img: "/assets/frontendMentorChallenges.png",
      link:"https://jpj-frontendmentor-solutions.herokuapp.com/"
    }

  ];
  
  export const dataengineeringPortfolio = [
    {
      id: 1,
      title: "NY Parking Tickets Analysis",
      img:
        "/assets/Apache_Spark_logo.png",
      link: "https://github.com/jibujacob/NY_Parking_Tickets_Exploratory_Analysis"
    },
    {
      id: 2,
      title: "ATM Analysis",
      img:
        "/assets/hivetospark10.png",
      link:"https://github.com/jibujacob/ATM_Analysis"
    },
    {
      id: 3,
      title: "Retail Streaming Analysis",
      img:
        "/assets/kafka-sparkstream.jpeg",
      link:"https://github.com/jibujacob/Retail_Streaming_Analysis"
    },
  ];
  
  export const pipelinedprojectsPortfolio=[
    {
      id: 1,
      title: "Ecommerce Inventory WebApp",
      img:
        "/assets/Ecommerce Inventory.png",
      link: "https://github.com/jibujacob/AdminUIReact"
    },

  ]